/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_ClassInputs */

const en_features_sample_class = /** @type {(inputs: Features_Sample_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group mobility`)
};

const pl_features_sample_class = /** @type {(inputs: Features_Sample_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobility w grupie`)
};

/**
* | output |
* | --- |
* | "Group mobility" |
*
* @param {Features_Sample_ClassInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_class = /** @type {((inputs?: Features_Sample_ClassInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_ClassInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_class(inputs)
	return en_features_sample_class(inputs)
});